import installer from './defaults'
export * from '@pc-fx-framework/components'
export * from '@pc-fx-framework/directives'
export * from '@pc-fx-framework/hooks'
export * from '@pc-fx-framework/tokens'
export * from '@pc-fx-framework/utils'

export { default as makeInstaller } from './make-installer'
export { default } from './defaults'

export const install = installer.install
export const version = installer.version
